export default function Checkbox({
  labelText,
  checked,
  style,
  disabled,
  onChange,
}: Object): React.Element {
  return (
    <label
      style={{
        display: 'block',
        color: disabled ? '#ccc' : 'rgba(0,0,0,0.87)',
        ...style,
      }}
      >
      <input
        checked={checked}
        onChange={onChange}
        type="checkbox"
        disabled={disabled}
        style={{ margin: '0 5px 0 5px' }}
        />
      { labelText }
    </label>
  );
}
